import React from 'react';
import Page from 'components/Page';
import {
  Button,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Input,
} from 'reactstrap';
import { Bar, Doughnut, } from 'react-chartjs-2';
import { NumberWidget } from 'components/Widget';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';
import { getColor } from 'utils/colors';
import BaseService from '../services/BaseService';

class ReportSpotPage extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      available_percent: 0,
      available_number: 0,
      unavailable_percent: 0,
      unavailable_number: 0,
      irregular_percent: 0,
      irregular_number: 0,
      date_from_most_user_spot: '',
      date_to_most_user_spot: '',
      date_from_irregular_parking_spot: '',
      date_to_irregular_parking_spot: '',
      date_from_total_sale: '',
      date_to_total_sale: '',
      cols_total_sale: 0,
      data_total_sale: 0,
      data_most_profitable_sectors: 0,
      cols_most_profitable_sectors: 0,
      cols_most_user_spot: 0,
      data_most_user_spot: 0,
      cols_irregular_parking_spot: 0,
      data_irregular_parking_spot: 0,
      date_to_most_profitable_sectors: '',
      date_from_most_profitable_sectors:  '',
      date_to_sales_per_entry: '',
      date_from_sales_per_entry: '',
      cols_sales_per_entry: 0,
      date_sales_per_entry: 0,
      dateFromMostUserSpotInvalid: false,
      dateToMostUserSpotInvalid: false,
      dateFromMostProfitableSectors: false,
      dateToMostProfitableSectors: false,
      dateToSalesPerEntry: false,
      dateFromSalesPerEntry: false,
      dateFromIrregularParkingSpotInvalid: false,
      dateToIrregularParkingSpotInvalid: false,
      dateFromTotalSaleInvalid: false,
      dateToTotalSaleInvalid: false,
    };
    this.genLineData = this.genLineData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getStatisctsStatusSpot = this.getStatisctsStatusSpot.bind(this);
    this.getStatisctsParkedSpot = this.getStatisctsParkedSpot.bind(this);
    this.getStatisctsIrregularParking = this.getStatisctsIrregularParking.bind(this);
    this.getStatisctsTotalSale = this.getStatisctsTotalSale.bind(this);
    this.getStatisctsSalesPerEntry = this.getStatisctsSalesPerEntry.bind(this);
    this.getMostProfitableSectors = this.getMostProfitableSectors.bind(this);
  }
  handleInputChange (event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  componentDidMount(){
    this.getStatisctsStatusSpot();
    this.getStatisctsParkedSpot();
    this.getStatisctsIrregularParking();
    this.getStatisctsTotalSale();
    this.getStatisctsSalesPerEntry();
    this.getMostProfitableSectors();
    this.genLineArrayData();
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.reload !== this.props.reload) {
      this.getStatisctsStatusSpot();
      this.getStatisctsParkedSpot();
      this.getStatisctsIrregularParking();
      this.getStatisctsTotalSale();
      this.getStatisctsSalesPerEntry();
      this.getMostProfitableSectors();
    }
  }
  randomColor(){ 
    const availableColors = [
      'blue',
      'indigo',
      'purple',
      'pink',
      'red',
      'orange',
      'yellow',
      'green',
      'teal',
      'cyan',
      'white',
      'gray',
      'gray-dark',
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return availableColors;
  }
  getPieData(cols, data) {
    return{
      labels: cols,
      datasets: [
        {
          label: '',
          backgroundColor: [
            getColor('blue'),
            getColor('green'),
            getColor('orange'),
            getColor('pink'),
            getColor('cyan'),
            getColor('red'),
            getColor('yellow'),
            getColor('indigo'),
            getColor('teal'),
            getColor('purple'),
            getColor('gray'),
            getColor('gray-dark'),
            getColor('primary'),
            getColor('secondary'),
            getColor('success'),
            getColor('info'),
            getColor('warning'),
            getColor('danger'),
            getColor('light'),
            getColor('dark')
          ],
          data: data,
        }
      ],
    }
  }
  genLineData(cols, data, color){
    return {
      labels: cols,
      datasets: [
        {
          label: '',
          backgroundColor: getColor(color),
          borderColor: getColor(color),
          borderWidth: 0,
          data: data,
        },
      ],
    };
  }
  genLineArrayData(labels, data){
    return {
      labels: labels,
      datasets: data
    }
  }
  getStatisctsStatusSpot() {
    fetch(BaseService.ENDPOINT + 'admin/statistics/status-spot',  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          available_percent:   data.data.available.percent,
          available_number:    data.data.available.number,
          unavailable_percent: data.data.unavailable.percent,
          unavailable_number:  data.data.unavailable.number,
          irregular_percent:   data.data.irregular.percent,
          irregular_number:    data.data.irregular.number,
        });
      }else if(data.return.code>300){
        window.location = '/';
      }
    })
  }
  getStatisctsSalesPerEntry() {
    var date_from = this.state.date_from_sales_per_entry.toString().replace('/', '-').replace('/', '-');
    var date_to = this.state.date_to_sales_per_entry.toString().replace('/', '-').replace('/', '-');

    if(date_from===''){
      date_from = '1';
    }
    if(date_to===''){
      date_to = '1';
    }

    const url = BaseService.ENDPOINT + 'admin/statistics/sales-types/'+date_from+'/'+date_to;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          cols_sales_per_entry: data.data.col,
          data_sales_per_entry: data.data.data,
        });
        if(date_from==='1'){
          this.setState({
            date_from_sales_per_entry: data.data.date.from,
          })
        }
        if(date_to==='1'){
          this.setState({
            date_to_sales_per_entry: data.data.date.to,
          })
        }
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  getMostProfitableSectors() {
    var date_from = this.state.date_from_most_profitable_sectors.replace('/', '-').replace('/', '-');
    var date_to = this.state.date_to_most_profitable_sectors.replace('/', '-').replace('/', '-');

    if(date_from===''){
      date_from = '1';
    }
    if(date_to===''){
      date_to = '1';
    }

    const url = BaseService.ENDPOINT + 'admin/statistics/profitable-sectors/'+date_from+'/'+date_to;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          cols_most_profitable_sectors: data.data.labels,
          data_most_profitable_sectors: data.data.datasets,
        });
        if(date_from==='1'){
          this.setState({
            date_from_most_profitable_sectors: data.data.date.from,
          })
        }
        if(date_to==='1'){
          this.setState({
            date_to_most_profitable_sectors: data.data.date.to,
          })
        }
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  getStatisctsParkedSpot() {
    var date_from = this.state.date_from_most_user_spot.replace('/', '-').replace('/', '-');
    var date_to = this.state.date_to_most_user_spot.replace('/', '-').replace('/', '-');

    if(date_from===''){
      date_from = '1';
    }
    if(date_to===''){
      date_to = '1';
    }

    const url = BaseService.ENDPOINT + 'admin/statistics/parked-spot/'+date_from+'/'+date_to;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          cols_most_user_spot: data.data.col,
          data_most_user_spot: data.data.data,
        });
        if(date_from==='1'){
          this.setState({
            date_from_most_user_spot: data.data.date.from,
          })
        }
        if(date_to==='1'){
          this.setState({
            date_to_most_user_spot: data.data.date.to,
          })
        }
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  getStatisctsIrregularParking() {
    var date_from = this.state.date_from_irregular_parking_spot.replace('/', '-').replace('/', '-');
    var date_to = this.state.date_to_irregular_parking_spot.replace('/', '-').replace('/', '-');

    if(date_from===''){
      date_from = '1';
    }
    if(date_to===''){
      date_to = '1';
    }

    const url = BaseService.ENDPOINT + 'admin/statistics/irregular-parking/'+date_from+'/'+date_to;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          cols_irregular_parking_spot: data.data.col,
          data_irregular_parking_spot: data.data.data,
        });
        if(date_from==='1'){
          this.setState({
            date_from_irregular_parking_spot: data.data.date.from,
          })
        }
        if(date_to==='1'){
          this.setState({
            date_to_irregular_parking_spot: data.data.date.to,
          })
        }
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  getStatisctsTotalSale() {
    var date_from = this.state.date_from_total_sale.replace('/', '-').replace('/', '-');
    var date_to = this.state.date_to_total_sale.replace('/', '-').replace('/', '-');

    if(date_from===''){
      date_from = '1';
    }
    if(date_to===''){
      date_to = '1';
    }

    const url = BaseService.ENDPOINT + 'admin/statistics/sales-parking/'+date_from+'/'+date_to;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({
          cols_total_sale: data.data.col,
          data_total_sale: data.data.data,
        });
        if(date_from==='1'){
          this.setState({
            date_from_total_sale: data.data.date.from,
          })
        }
        if(date_to==='1'){
          this.setState({
            date_to_total_sale: data.data.date.to,
          })
        }
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  render() {
    return (
      <Page
        title="Relatório de Vagas"
        className="ReportSpotPage">
        <Row>
          <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
            <NumberWidget
              title="Vagas Livres"
              subtitle="Por dia"
              number={this.state.available_number}
              color="primary"
              progress={{
                value: this.state.available_percent
              }}
            />
          </Col>
          <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
            <NumberWidget
              title="Vagas Ocupadas"
              subtitle="Por dia"
              number={this.state.unavailable_number}
              color="warning"
              progress={{
                value: this.state.unavailable_percent
              }}
            />
          </Col>
          <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
            <NumberWidget
              title="Vagas Irregulares"
              subtitle="Por dia"
              number={this.state.irregular_number}
              color="danger"
              progress={{
                value: this.state.irregular_percent
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'green', color: '#FFFFFF'}}>TOP 10 - Vagas mais utilizadas</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_most_user_spot"
                            value={this.state.date_from_most_user_spot}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromMostUserSpotInvalid}
                            max={this.state.date_to_most_user_spot}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_most_user_spot"
                            value={this.state.date_to_most_user_spot}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToMostUserSpotInvalid}
                            min={this.state.date_from_most_user_spot}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getStatisctsParkedSpot}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Bar data={this.genLineData(this.state.cols_most_user_spot, this.state.data_most_user_spot, 'green')} />
              </CardBody>
            </Card>
          </Col>
          <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: '#B30000', color: '#FFFFFF'}}>Estacionamentos Irregulares</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_irregular_parking_spot"
                            value={this.state.date_from_irregular_parking_spot}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromIrregularParkingSpotInvalid}
                            max={this.state.date_to_irregular_parking_spot}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_irregular_parking_spot"
                            value={this.state.date_to_irregular_parking_spot}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToIrregularParkingSpotInvalid}
                            min={this.state.date_from_irregular_parking_spot}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getStatisctsIrregularParking}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Bar data={this.genLineData(this.state.cols_irregular_parking_spot, this.state.data_irregular_parking_spot, 'red')} />
              </CardBody>
            </Card>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'purple', color: '#FFFFFF'}}>Total de Vendas por Período</CardHeader>
              <CardBody>
                <Row>
                    <Col>
                    <FormGroup row>
                        <Label sm={2}>De:</Label>
                        <Col>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_total_sale"
                            value={this.state.date_from_total_sale}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromTotalSaleInvalid}
                            max={this.state.date_to_total_sale}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col>
                    <FormGroup row>
                        <Label sm={3}>até:</Label>
                        <Col>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_total_sale"
                            value={this.state.date_to_total_sale}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToTotalSaleInvalid}
                            min={this.state.date_from_total_sale}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getStatisctsTotalSale}
                      >Procurar</Button>
                    </Col>
                </Row>
                <Bar data={this.genLineData(this.state.cols_total_sale, this.state.data_total_sale, 'purple')} />
              </CardBody>
            </Card>
          </Col>
          <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'orange', color: '#FFFFFF'}}>Vendas por Entradas</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_sales_per_entry"
                            value={this.state.date_from_sales_per_entry}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromSalesPerEntry}
                            max={this.state.date_to_sales_per_entry}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_sales_per_entry"
                            value={this.state.date_to_sales_per_entry}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToSalesPerEntry}
                            min={this.state.date_from_sales_per_entry}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getStatisctsSalesPerEntry}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Doughnut data={this.getPieData(this.state.cols_sales_per_entry, this.state.data_sales_per_entry)} />
              </CardBody>
            </Card>
          </Col>
          <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'blue', color: '#FFFFFF'}}>Setores mais rentáveis por Dia</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_most_profitable_sectors"
                            value={this.state.date_from_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromMostProfitableSectors}
                            max={this.state.date_to_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_most_profitable_sectors"
                            value={this.state.date_to_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToMostProfitableSectors}
                            min={this.state.date_from_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getMostProfitableSectors}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Bar data={this.genLineArrayData(this.state.cols_most_profitable_sectors, this.state.data_most_profitable_sectors)} />
              </CardBody>
            </Card>
          </Col>
{/*           <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'black', color: '#FFFFFF'}}>Vagas Regulares/Irregulares por dia</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_most_profitable_sectors"
                            value={this.state.date_from_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromMostProfitableSectors}
                            max={this.state.date_to_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_most_profitable_sectors"
                            value={this.state.date_to_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToMostProfitableSectors}
                            min={this.state.date_from_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getMostProfitableSectors}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Doughnut data={
                  {
                    labels: ["Vagas Regulares", "Vagas Irregulares"],
                    datasets: [
                      {
                        label: '',
                        backgroundColor: [
                          getColor('blue'),
                          getColor('green'),
                          getColor('orange'),
                          getColor('pink'),
                          getColor('cyan'),
                          getColor('red'),
                          getColor('yellow'),
                          getColor('indigo'),
                          getColor('teal'),
                          getColor('purple'),
                          getColor('gray'),
                          getColor('gray-dark'),
                          getColor('primary'),
                          getColor('secondary'),
                          getColor('success'),
                          getColor('info'),
                          getColor('warning'),
                          getColor('danger'),
                          getColor('light'),
                          getColor('dark')
                        ],
                        data: [33, 1],
                      }
                    ],
                  }
                } />
              </CardBody>
            </Card>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12} className="mb-3">
          <Card>
              <CardHeader style={{backgroundColor: 'green', color: '#FFFFFF'}}>Vagas Totais por período</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_most_profitable_sectors"
                            value={this.state.date_from_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromMostProfitableSectors}
                            max={this.state.date_to_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_most_profitable_sectors"
                            value={this.state.date_to_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToMostProfitableSectors}
                            min={this.state.date_from_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getMostProfitableSectors}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
              <NumberWidget
                title="Total"
                number={120}
                color="primary"
                progress={{
                  value: 100
                }}
              />
              </CardBody>
          </Card>
          </Col>
          <Col xl={6} lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader style={{backgroundColor: 'purple', color: '#FFFFFF'}}>Taxa de Respeito</CardHeader>
              <CardBody>
                <Row>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>De</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_from_most_profitable_sectors"
                            value={this.state.date_from_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateFromMostProfitableSectors}
                            max={this.state.date_to_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <FormGroup row>
                        <Label sm={3}>até</Label>
                        <Col sm={9}>
                          <Input
                            type="date"
                            maxLength={10}
                            name="date_to_most_profitable_sectors"
                            value={this.state.date_to_most_profitable_sectors}
                            onChange={this.handleInputChange}
                            invalid={this.state.dateToMostProfitableSectors}
                            min={this.state.date_from_most_profitable_sectors}
                          ></Input>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <Col sm={3}>
                      <Button
                        outline
                        color="primary"
                        onClick={this.getMostProfitableSectors}
                      >Procurar</Button>
                    </Col>
                  </Col>
                </Row>
                <Doughnut data={
                  {
                    labels: ["Teste", "Teste"],
                    datasets: [
                      {
                        label: '',
                        backgroundColor: [
                          getColor('indigo'),
                          getColor('teal'),
                          getColor('gray'),
                          getColor('primary'),
                          getColor('secondary'),
                          getColor('success'),
                          getColor('info'),
                          getColor('warning'),
                          getColor('danger'),
                          getColor('light'),
                          getColor('green'),
                          getColor('orange'),
                          getColor('pink'),
                          getColor('blue'),
                          getColor('cyan'),
                          getColor('gray-dark'),
                          getColor('red'),
                          getColor('yellow'),
                          getColor('purple'),
                          getColor('dark')
                        ],
                        data: [33, 1],
                      }
                    ],
                  }
                } />
              </CardBody>
            </Card>
          </Col> */}
        </Row>
      </Page>
    );
  }
};

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(ReportSpotPage)


// WEBPACK FOOTER //
// ./src/pages/ReportSpotPage.js